import React, { createContext, useReducer, useEffect, useContext, ReactNode, JSX } from 'react'
import { initialState, ProfileActionTypes, profileReducer, ProfileState } from './profileReducer'
import { profileInit, profileLogout } from './profileAction'
import { AuthContext } from '../auth'

interface ProfileContextType {
  profileState?: ProfileState
  profileDispatch?: React.Dispatch<ProfileActionTypes>
}

export const ProfileContext = createContext<ProfileContextType>({ profileState: initialState })

export const ProfileProvider = (props: { rootUrl: string, children: ReactNode }): JSX.Element => {
  const { authState } = useContext(AuthContext)
  const [profileState, profileDispatch] = useReducer(profileReducer, initialState)

  useEffect((): void => {
    if (authState.authToken) {
      void profileInit(profileDispatch, props.rootUrl, null).then()
    } else {
      profileLogout(profileDispatch)
    }
  }, [authState.authToken])

  return (
    <ProfileContext.Provider value={{ profileState, profileDispatch }}>
      {props.children}
    </ProfileContext.Provider>
  )
}
